module.exports = __webpack_public_path__ + "static/media/HAYDIROKET-COVIDEO.95a0e661.MP4";